import { Lead } from '@/types';
import { CallCenterBucket } from '../dashboard';

export const featurePath = '/v4/callcenter/assignments';

export type ActivityType = 'viewing' | 'typing' | 'dialing';

export type ReleaseReason =
  | 'language_barrier'
  | 'duplicate'
  | 'wrong_fit'
  | 'personal_conflict'
  | 'other';

export type ReleaseAssignmentDTO = { reason: ReleaseReason };

// Raw Eloquent model shape returned by accept -- deliberately different from
// the dashboard's QueueItem projection (see `LeadAgentAssignment` in the API repo).
export type AcceptedAssignment = {
  lead_agent_assignment_id: number;
  lead_id: number;
  user_id: number;
  state: string;
  priority_bucket: CallCenterBucket;
  rotation_count: number;
  rotated_from_id: number | null;
  reason: string | null;
  assigned_at: string | null;
  accepted_at: string | null;
  first_activity_at: string | null;
  last_activity_at: string | null;
  ended_at: string | null;
  sla_deadline_at: string | null;
  nudged_at: string | null;
  externally_held_at: string | null; // timestamp, NOT a boolean
  created_at: string;
  updated_at: string;
  lead: Lead;
};
